import NodeCache from 'node-cache';

const nodeCache = new NodeCache();

export default nodeCache;
